/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrganizationUserResource } from '../models/OrganizationUserResource'
import type { PermissionFormatQuery } from '../models/PermissionFormatQuery'

import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class OrganizationsUsersService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List organization users.
     * @returns any OK
     * @throws ApiError
     */
    public getOrganizationUsers({
        id,
        admins = false,
        format
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
        /**
         * Filter users to only those with admin permissions
         */
        admins?: boolean
        /**
         * Permission Format
         */
        format?: PermissionFormatQuery
    }): CancelablePromise<{
        data: Array<OrganizationUserResource>
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organizations/{id}/users',
            path: {
                id: id
            },
            query: {
                admins: admins,
                format: format
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * Get organization user.
     * @returns any OK
     * @throws ApiError
     */
    public getOrganizationUser({
        organizationId,
        id,
        format
    }: {
        /**
         * Organization ID
         */
        organizationId: number
        /**
         * ID of the retrieved resource.
         */
        id: number
        /**
         * Permission Format
         */
        format?: PermissionFormatQuery
    }): CancelablePromise<{
        data: OrganizationUserResource
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organizations/{organizationId}/users/{id}',
            path: {
                organizationId: organizationId,
                id: id
            },
            query: {
                format: format
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public updateOrganizationUser({
        organizationId,
        id,
        requestBody
    }: {
        /**
         * Organization ID
         */
        organizationId: number
        /**
         * ID of the retrieved resource.
         */
        id: number
        requestBody: {
            username?: string
            /**
             * Reset the email address for this user. Will remove email verification unless included.
             */
            email?: string
            /**
             * Set email verification status. If email MFA is on, you will need to disable MFA too
             */
            email_verified?: boolean | null
            role_id?: number | null
            /**
             * Disable multi-factor authentication for this user
             */
            disable_mfa?: boolean
            /**
             * Make this user the primary user for the organization
             */
            make_primary?: boolean
            first_name?: string
            last_name?: string
            password?: string
            format?: PermissionFormatQuery
        }
    }): CancelablePromise<{
        data: OrganizationUserResource
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/organizations/{organizationId}/users/{id}',
            path: {
                organizationId: organizationId,
                id: id
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }
}
